// FIXME: Fix import/named export issue for firebase
/* eslint-disable import/named */
import {
	verifyPasswordResetCode,
	confirmPasswordReset,
	checkActionCode,
	applyActionCode,
	sendPasswordResetEmail,
	sendEmailVerification
} from 'firebase/auth'
import firebaseUser from './auth-user'

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} actionCode
 */
function handleVerifyPasswordResetCode (firebaseAuth, actionCode) {
	return verifyPasswordResetCode(firebaseAuth, actionCode)
	// .then((accountEmail) => {})
	// .catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} actionCode
 * @param {string} newPassword
 */
function handleConfirmPasswordReset (firebaseAuth, actionCode, newPassword) {
	return confirmPasswordReset(firebaseAuth, actionCode, newPassword)
	// .then((resp) => {
	// 	// TODO: Display a link back to the app, or sign-in the user directly
	// 	// if the page belongs to the same domain as the app:
	// 	// auth.signInWithEmailAndPassword(accountEmail, newPassword);
	// })
	// .catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} actionCode
 */
function handleApplyRecoverEmailActionCode (firebaseAuth, actionCode) {
	return checkActionCode(firebaseAuth, actionCode)
		.then((info) => {
		    // Get the restored email address.
			// restoredEmail = info.data.email

			// Revert to the old email.
			return applyActionCode(firebaseAuth, actionCode)
		})
		// .catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} actionCode
 */
function handleApplyVerificationEmailActionCode (firebaseAuth, actionCode) {
	return applyActionCode(firebaseAuth, actionCode)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} email
 */
function handleSendPasswordResetEmail (firebaseAuth, email) {
	const actionCodeSettings = {
		url: `${window.location.origin}/my/profile/my-pixellot/`
	}

	return sendPasswordResetEmail(firebaseAuth, email, actionCodeSettings)
	// .then(() => {
	// // Password reset confirmation sent. Ask user to check their email.
	// })
	// .catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 */
async function handleSendEmailVerification (firebaseAuth) {
	const actionCodeSettings = {
		url: `${window.location.origin}/my/profile/my-pixellot/`
	}
	const currentUser = await firebaseUser.getUser(firebaseAuth, false)

	return sendEmailVerification(currentUser, actionCodeSettings)
	// .catch(firebaseError.parseError)
}

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} actionCode
 */
function handleUnEnrollMfaByActionCode (firebaseAuth, actionCode) {
	return applyActionCode(firebaseAuth, actionCode)
}

export default {
	handleVerifyPasswordResetCode,
	handleConfirmPasswordReset,
	handleApplyRecoverEmailActionCode,
	handleApplyVerificationEmailActionCode,
	handleSendPasswordResetEmail,
	handleSendEmailVerification,
	handleUnEnrollMfaByActionCode
}
